import {CouponByEvent} from "@QUERIES/prdt/coupon/useCouponByEvent";

const isApplicableByGoodsPrice = (coupon: CouponByEvent, adtPrice?: number | string) =>
	coupon.goodsPriceCd === null || // 상품가 없는 경우
	coupon.goodsPriceCd === "TOT" || // 상품가 총액인경우
	(coupon.goodsPriceCd === "PER" && adtPrice != null && Number(coupon.goodsPriceFr) < Number(adtPrice)); // 상품가 1인당 가격이 상품가보다 작은경우

const pickExclusiveCoupon = (coupons: CouponByEvent[], getDiscount: (coupon: CouponByEvent) => number) => {
	if (coupons.length === 0) return undefined;

	return coupons.reduce((best, current) => {
		const bestAmt = getDiscount(best);
		const currentAmt = getDiscount(current);
		if (currentAmt !== bestAmt) return currentAmt > bestAmt ? current : best;

		const bestDt = best.issueFrDt ?? "";
		const currentDt = current.issueFrDt ?? "";
		if (currentDt !== bestDt) return currentDt > bestDt ? current : best;

		return best;
	});
};

const sortByGoodsPriceFr = (coupons: CouponByEvent[]) => {
	const nullList = coupons.filter(c => c.goodsPriceFr === null);
	const valueList = coupons
		.filter(c => c.goodsPriceFr !== null)
		.sort((a, b) => Number(b.goodsPriceFr) - Number(a.goodsPriceFr));

	return [...nullList, ...valueList];
};

/** 상세 페이지 사용 가능 쿠폰 노출 목록 */
const getDisplayCouponsByEvent = (coupons: CouponByEvent[] | undefined, adtPrice?: number | string) => {
	if (!coupons) return [];

	const filtered = coupons.filter(c => isApplicableByGoodsPrice(c, adtPrice));
	const multiUse = filtered.filter(c => c.multiUseYn === "Y");
	const exclusive = filtered.filter(c => c.multiUseYn !== "Y");
	const pickedAmt = pickExclusiveCoupon(
		exclusive.filter(c => c.discDiviCd === "M"),
		c => Number(c.discAmt),
	);
	const pickedRate = pickExclusiveCoupon(
		exclusive.filter(c => c.discDiviCd !== "M"),
		c => Number(c.discRate),
	);

	return sortByGoodsPriceFr([...multiUse, ...(pickedAmt ? [pickedAmt] : []), ...(pickedRate ? [pickedRate] : [])]);
};

// eslint-disable-next-line import/prefer-default-export
export {getDisplayCouponsByEvent};
